class ConfigUrl {
    // 开发/测试环境
    // ordinaryUrl = "http://192.168.10.18:8980/";//普通路径配置
    // ordinaryUrl = "https://shx.logimis.com/api/";//普通路径配置
    // questionUrl = "https://shx.logimis.com/";//北京问卷地址
    // redirectUri ="https://iumswxtest.logimis.com/";//授权跳转页面


    // 生产环境
    ordinaryUrl = "https://iumsserver.logimis.com/" // 北京正式生产环境地址
    questionUrl = "https://iumsserver.logimis.com/"//北京问卷地址
    redirectUri ="https://wx.union.logimis.com/";//授权跳转页面
    // questionUrl = "https://pvqapi.logimis.com/";//北京问卷地址
    
}
let configUrl = new ConfigUrl();
export default configUrl;